import DashboardLayout from '@/pages/DashboardLayout.vue'
import Login from '@/pages/Login.vue'
import LoginLayout from '@/pages/Dashboard/Layout/LoginLayout.vue'
// Dashboard pages
import Intents from '@/pages/Intents.vue'
import Entitites from '@/pages/Entitites.vue'
import Dialog from '@/pages/Dialog.vue'
import Relatorios from '@/pages/Relatorios.vue'
import Settings from '@/pages/Settings.vue'
import DashboardGeneral from '@/pages/DashboardGeneral.vue'
import Efficiency from '@/pages/Efficiency.vue'
import CanalMessenger from '@/pages/CanalMessenger.vue'
import CanalInstagram from '@/pages/CanalInstagram.vue'
import CanalWeb from '@/pages/CanalWeb.vue'
// import CanalInstagram from '@/pages/CanalInstagram.vue'
import CanalLivezilla from '@/pages/CanalLivezilla.vue'
import ListaAssistentes from '@/pages/ListaAssistentes.vue'
import ListaUsuarios from '@/pages/ListaUsuarios.vue'
import UserEdit from '@/pages/UserEdit.vue'
import Snapshots from '@/pages/Snapshots.vue'
import Workspaces from '@/pages/Workspaces.vue'
import Workspace from '@/pages/Workspace.vue'
import SimplifiedEditing from '@/pages/SimplifiedEditing.vue'
import SimplifiedEditingWorkspaceVersion from '@/pages/SimplifiedEditingWorkspaceVersion.vue'
import SimplifiedEditingTable from '@/pages/SimplifiedEditingTable.vue'
import ChatHistory from '@/pages/ChatHistory.vue'
import AccessLog from '@/pages/AccessLog.vue'
import EventAuthHistory from '@/pages/EventAuthHistory.vue'
import ProductivityHistory from '@/pages/ProductivityHistory.vue'
import Templates from '@/pages/Templates.vue'
import NotificationCampaign from '@/pages/NotificationCampaign.vue'
import OperatorsJourney from '@/pages/OperatorsJourney.vue'
import Auth from '@/pages/Auth.vue'
import SearchMessages from '@/pages/SearchMessages.vue'
import Curatorship from '@/pages/Curatorship.vue'
import MessagesNotUnderstood from '@/pages/MessagesNotUnderstood.vue'
import AnalysisPerServiceDelivered from '@/pages/AnalysisPerServiceDelivered.vue'
import CallbackGerid from '@/gerid/CallbackGerid.vue'
import CampaignAnalysis from '@/pages/CampaignAnalysis.vue'
import CampaignList from '@/pages/CampaignList.vue'
import VerifyTeamsUser from '@/pages/VerifyTeamsUser.vue'
import GraphApiConfirmation from '@/pages/GraphApiConfirmation.vue'
import ManageAccessUser from '@/pages/ManageAccessUser.vue'
import ManageAccessUserProfile from '@/pages/ManageAccessUserProfile.vue'
import ManageAccessFunctionalities from '@/pages/ManageAccessFunctionalities.vue'
import ActiveContacts from '@/pages/ActiveContacts.vue'

const routes = [
  {
    path: '/',
    redirect: '/visao-geral',
    name: 'Home',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/',
    component: DashboardLayout,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'intents',
        name: 'routes.intentions',
        components: { default: Intents }
      },
      {
        path: 'entities',
        name: 'routes.entities',
        components: { default: Entitites }
      },
      {
        path: 'dialog',
        name: 'routes.dialogue',
        components: { default: Dialog }
      },
      {
        path: 'relatorios',
        name: 'routes.reports',
        components: { default: Relatorios }
      },
      {
        path: 'settings',
        name: 'routes.generalSettings',
        component: Settings
      },
      {
        path: 'visao-geral',
        name: 'routes.overview',
        components: { default: DashboardGeneral }
      },
      {
        path: 'eficiencia',
        name: 'routes.efficiencyOfAssistantResponses',
        components: { default: Efficiency }
      },
      {
        path: 'canal-web',
        name: 'routes.webChannel',
        components: { default: CanalWeb }
      },
      {
        path: 'canal-livezilla',
        name: 'routes.livezillaChannel',
        components: { default: CanalLivezilla }
      },
      {
        path: '/canal-messenger',
        name: 'routes.messengerChannel',
        components: { default: CanalMessenger }
      },
      {
        path: '/canal-instagram',
        name: 'routes.instagramChannel',
        components: { default: CanalInstagram }
      },
      {
        path: '/lista-assistentes',
        name: 'routes.listOfCognitiveAssistants',
        components: { default: ListaAssistentes }
      },
      {
        path: 'lista-usuarios',
        name: 'routes.listOfUsers',
        components: { default: ListaUsuarios }
      },
      {
        path: 'user-edit',
        name: 'routes.editUser',
        components: { default: UserEdit }
      },
      {
        path: 'snapshots',
        name: 'Snapshots',
        components: { default: Snapshots }
      },
      {
        path: 'workspaces',
        name: 'Workspaces',
        components: { default: Workspaces }
      },
      {
        path: 'workspace',
        name: 'Workspace',
        components: { default: Workspace }
      },
      {
        path: 'edicao-simplificada',
        name: 'routes.simplifiedEditing',
        components: { default: SimplifiedEditing }
      },
      {
        path: 'selecionar-versao-workspace',
        name: 'routes.simplifiedEditing',
        components: { default: SimplifiedEditingWorkspaceVersion }
      },
      {
        path: 'chatbuilder',
        name: 'routes.chatbuilder',
        components: { default: SimplifiedEditingTable }
      },
      {
        path: 'historico-conversas',
        name: 'routes.conversationHistory',
        components: { default: ChatHistory }
      },
      {
        path: 'auditoria-atendimento',
        name: 'routes.serviceAudit',
        components: { default: EventAuthHistory }
      },
      {
        path: 'log-acesso',
        name: 'Log de Acessos',
        components: { default: AccessLog }
      },
      {
        path: 'busca-por-mensagens',
        name: 'routes.searchByMessages',
        components: { default: SearchMessages }
      },
      {
        path: 'historico-produtividade',
        name: 'routes.productivityHistory',
        components: { default: ProductivityHistory }
      },
      {
        path: 'templates',
        name: 'Templates',
        components: { default: Templates }
      },
      {
        path: 'campanhas',
        name: 'routes.campaign',
        components: { default: NotificationCampaign }
      },
      {
        path: 'jornada-do-operador',
        name: 'routes.operatorJourney',
        components: { default: OperatorsJourney }
      },
      {
        path: 'provider-autenticacao',
        name: 'routes.authenticationProvider',
        components: { default: Auth }
      },
      {
        path: 'curadoria',
        name: 'routes.curatorship',
        components: { default: Curatorship }
      },
      {
        path: 'mensagens-nao-entendidas',
        name: 'routes.messagesNotUnderstood',
        components: { default: MessagesNotUnderstood }
      },
      {
        path: 'analise-por-servico-entregue',
        name: 'routes.analysisPerServiceDelivered',
        components: { default: AnalysisPerServiceDelivered }
      },
      {
        path: 'campanha-desempenho-geral',
        name: 'routes.campaignAnalysis',
        components: { default: CampaignAnalysis }
      },
      {
        path: 'lista-campanhas',
        name: 'routes.campaignFiredList',
        components: { default: CampaignList }
      },
      {
        path: 'consulta-usuario-teams',
        name: 'routes.verifyTeamsUserService',
        components: { default: VerifyTeamsUser }
      },
      {
        path: 'users',
        name: 'routes.listOfUsers',
        components: { default: ManageAccessUser }
      },
      {
        path: 'configuracoes-usuario-perfil',
        name: 'routes.listOfUsers',
        components: { default: ManageAccessUserProfile }
      },
      {
        path: 'configuracoes-funcionalidades',
        name: 'routes.listOfUsers',
        components: { default: ManageAccessFunctionalities }
      },
      {
        path: 'contatos-ativos',
        name: 'activeContacts.activeContacts',
        components: { default: ActiveContacts }
      }
    ]
  },
  {
    path: '/admin-graph-confirmation',
    name: 'GraphConfirmation',
    component: GraphApiConfirmation,
    meta: {
      guest: true
    }
  },
  {
    path: '/',
    component: LoginLayout,
    name: 'Authentication',
    children: [
      {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
          guest: true
        }
      }
    ]
  },
  {
    path: '/gerid/callback',
    component: CallbackGerid,
    name: 'AuthenticationGerid'
  }
]

export default routes
